(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionController', SSFuncionController);

    SSFuncionController.$inject = ['SSFuncion'];

    function SSFuncionController(SSFuncion) {

        var vm = this;

        vm.sSFuncions = [];

        loadAll();

        function loadAll() {
            SSFuncion.query(function(result) {
                vm.sSFuncions = result;
                vm.searchQuery = null;
            });
        }
    }
})();
